module.exports = __webpack_public_path__ + "static/media/restore.da28bae9.png";